// actions.js
import * as actionTypes from './actionsTypes';

export const setValueReserv = (newValue) => ({
  type: actionTypes.SET_VALUE_R,
  payload: newValue
});

export const setStatutReserv = (newStatut) => ({
  type: actionTypes.SET_STATUT_R,
  payload: newStatut
});

export const setAnneeReserv = (newAnnee) => ({
  type: actionTypes.SET_ANNEE_R,
  payload: newAnnee
});


export const setCurrentPageReserv = (newCurrentPage) => ({
    type: actionTypes.SET_CURRENT_PAGE_R,
    payload: newCurrentPage
  });
  export const setSelectedOptionsReserv = (newSelectedOptions) => ({
    type: actionTypes.SET_SELECTED_OPTIONS_R,
    payload: newSelectedOptions
  });
  export const setSortFieldReserv = (newSortField) => ({
    type: actionTypes.SET_SORT_FIELD_R,
    payload: newSortField
  });
  export const setOrderReserv = (a) => ({
    type: actionTypes.SET_ORDER_R,
    payload: a
  });
  export const setAConfirmer = (a) => ({
    type: actionTypes.SET_A_CONFIRMER,
    payload: a
  });
  export const setARembourser = (a) => ({
    type: actionTypes.SET_A_REMBOURSER,
    payload: a
  });
  export const setAPlacer = (a) => ({
    type: actionTypes.SET_A_PLACER,
    payload: a
  });
  export const setFinalisees = (newOrder) => ({
    type: actionTypes.SET_FINALISEE,
    payload: newOrder
  });
  export const setAbandonnees = (newOrder) => ({
    type: actionTypes.SET_ABANDONNEES,
    payload: newOrder
  });
  
  
  

  
  